import { IContentModel } from '@ninjacart/nc-nk-core';
import {
  IRemoteVideoMetadata,
  getKisaanBaseURL,
  getStreamURI,
  toolId,
  useAppPersistenceStore,
  useFeedStore,
} from '@ninjacart/nc-nk-store';
import { getVersion } from 'react-native-device-info';
import { PlayListItem } from '../types/nkPlayerTypes';

export const transformToPlaylistItem = (
  item: IRemoteVideoMetadata,
  videoContent?: IContentModel,
  adDelay?: boolean | string
): PlayListItem => {
  const startPosition =
    item?.userHistory?.currentTime ??
    useFeedStore?.getState()?.currentLongVideoSelected?.actionData?.content?.userHistory
      ?.currentTime ??
    0;
  const needsReset = (startPosition / item?.duration) * 100 > 85;
  // console.log('Video reaching end. Needs reset => ', needsReset);
  const uniqueDeviceId = useAppPersistenceStore?.getState()?.deviceId;
  const adId = useAppPersistenceStore?.getState()?.adId;
  const isAdTrackingLimited = useAppPersistenceStore.getState().isAdTrackingLimited;
  const appVersion = getVersion();
  const delayInDuration = adDelay || adDelay === 'true' ? "&delay_in_secs=30": "";

  const playlistItem: PlayListItem = {
    itemSource: {
      source: {
        uri: item?.streamingPlaylistUrl?.toString() ?? item?.streamingPlaylists?.[0]?.playlistUrl,
        startPosition: needsReset ? 0 : startPosition * 1000,
      },
      poster: `${getStreamURI()}${item?.thumbnailPath}`,
      title: item?.name != "" ?item?.name : item?.description,
      itemKey: item?.id.toString(),
      // adTagUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=640x480&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator='
      adTagUrl: `${getKisaanBaseURL()}/ups/v1/tools/${toolId()}/devices/${uniqueDeviceId}/vast-ads?placement=nkvideoplayerpage&deviceAdId=${adId}&deviceIsLat=${isAdTrackingLimited}&size=200x300&source_video_id=${item?.id}&source_video_length=${item?.duration}&last_ad_played_at=1724751118&appVersion=${appVersion}${delayInDuration}`,
    },
  };

  return playlistItem;
};
